import { useEffect, useState } from "react";

import useGetDocumentVariablesTest, {
  useGetDocumentVariables,
  useGetDocumentVariablesPages,
} from "../hooks/useDocumentVariable";
import { getCaseId, getClientId } from "../../../../Utils/helper";
import AddEditDocumentVariable from "../modals/addEditDocumentVariable";
import NavLetterTemplates from "../nav-tabs-dyamic";
import TableFirmSettings from "../../common/table-firm-settings";
import api from "../../../../api/api";
import "./doc-var.css";
const DocumentVariables = () => {
  const [pageId, setPageId] = useState("all");
  const [editingVariable, setEditingVariable] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredVariables, setFilteredVariables] = useState([]);
  const { data, loading, refetch } = useGetDocumentVariablesTest();
  const { data: getVariablesPages } = useGetDocumentVariablesPages();
  const {
    data: getDocumentVariables,
    loading: variablesLoading,
    error: _variablesError,
    refetch: documentVariablesRefetch,
  } = useGetDocumentVariables({ page_id: pageId });

  const fetchVariableDetails = async (variableId) => {
    try {
      const response = await api.get("/api/firmsetting-page/edit-document-variable/", {
        params: { variable_id: variableId },
      });
      setEditingVariable(response.data);
      setShowEditModal(true);
    } catch (error) {
      console.error("Error fetching variable details:", error);
    }
  };
  const isProduction = process.env.NODE_ENV === "production";
  const replaceBaseUrl = (url) => {
    const newBaseUrl = isProduction
      ? `https://react-dev.simplefirm.com/bp-wordprocessor/${getClientId()}/${getCaseId()}`
      : `http://localhost:3000/bp-wordprocessor/${getClientId()}/${getCaseId()}`;

    const urlObj = new URL(url);
    const docId = urlObj.searchParams.get("docId");

    const finalUrl = `${newBaseUrl}?docId=${docId}`;
    return finalUrl;
  };

  const handleTabChange = (id) => {
    setPageId(id);
    documentVariablesRefetch(id);
  };

  const handleSearch = () => {
    if (getDocumentVariables) {
      const filtered = getDocumentVariables.filter(
        (variable) =>
          variable.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          variable.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
          variable.value.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredVariables(filtered);
    }
  };

  useEffect(() => {
    if (!searchTerm) {
      setFilteredVariables(getDocumentVariables || []);
    }
  }, [getDocumentVariables, searchTerm]);

  useEffect(() => {
    if (data && data.url) {
      const url = replaceBaseUrl(data.url);
      window.open(url, "_blank");
    }
  }, [data]);
  return (
    <>
      <div className="d-flex justify-content-between overflow-hidden">
        <button
          onClick={() => setShowAddModal(true)}
          className="btn btn-primary float-end d-flex align-items-center height-25 m-t-5 m-b-5"
        >
          Add Variable
        </button>
        <button
          onClick={() => refetch(pageId)}
          disabled={loading}
          className="btn btn-primary d-flex align-items-center height-25 m-t-5 m-b-5 m-r-5"
        >
          Document Variables Test
        </button>
      </div>

      <NavLetterTemplates
        pages={getVariablesPages || []}
        activeTab={pageId}
        handleTabChange={handleTabChange}
      />
      <div className="mb-1 mt-1 w-100 d-flex align-items-center justify-content-end">
        <input
          type="text"
          style={{
            maxWidth: "500px",
          }}
          className="form-control d-flex col-sm-2 height-25 py-0"
          placeholder="Search variables..."
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button
          className="btn btn-primary d-flex align-items-center height-25 ms-2 me-2"
          onClick={handleSearch}
        >
          Search
        </button>
      </div>
      {variablesLoading ? (
        <p>Loading...</p>
      ) : getDocumentVariables && getDocumentVariables.length > 0 ? (
        <div className="doc-vars-table">
          <TableFirmSettings>
            <colgroup>
              <col style={{ width: "25px" }} />
              <col style={{ width: "10%" }} />
              <col style={{ width: "5px" }} />
              <col style={{ width: "16%" }} />
              <col style={{ width: "5px" }} />
              <col style={{ width: "35%" }} />
              <col style={{ width: "5px" }} />
              <col style={{ width: "35%" }} />
              <col style={{ width: "5px" }} />
              <col style={{ width: "14%" }} />
            </colgroup>
            <thead>
              <tr>
                <th />
                <th className="text-center" style={{ fontWeight: "600" }}>
                  Page
                </th>
                <th />
                <th className="text-center" style={{ fontWeight: "600" }}>
                  Name
                </th>
                <th />
                <th className="text-center" style={{ fontWeight: "600" }}>
                  Description
                </th>
                <th />
                <th className="text-center" style={{ fontWeight: "600" }}>
                  Field
                </th>
                <th />
                <th className="text-center" style={{ fontWeight: "600" }}>
                  Button Name
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredVariables &&
                filteredVariables.length > 0 &&
                filteredVariables.map((variables, idx) => (
                  <tr key={idx} onClick={() => fetchVariableDetails(variables?.id)}>
                    <td
                      style={{ color: "var(--primary-25)", fontWeight: "600" }}
                      className="dt-type-numeric sorting_1"
                    >
                      {idx + 1}
                    </td>
                    <td>
                      <span className="d-flex align-items-center client-name-box account_text-ellipsis">
                        {variables?.for_page && (
                          <>
                            <span className="ic ic-15 d-flex align-items-center justify-content-center">
                              <img src={variables?.for_page?.page_icon} alt="" />
                            </span>
                            <span className="ms-1 text-black text-black-2 account_text-ellipsis">
                              {variables?.for_page?.name}
                            </span>
                          </>
                        )}
                      </span>
                    </td>
                    <td />
                    <td className="cell-wrap">{variables?.name}</td>
                    <td />
                    <td className="cell-wrap">{variables?.description}</td>
                    <td />
                    <td className="cell-wrap">{variables?.value}</td>
                    <td />
                    <td className="cell-wrap">{variables?.button_name}</td>
                  </tr>
                ))}
            </tbody>
          </TableFirmSettings>
        </div>
      ) : (
        <p>No document variables found.</p>
      )}

      {showAddModal && (
        <AddEditDocumentVariable
          show={showAddModal}
          size={"lg"}
          handleClose={() => setShowAddModal(false)}
          title={"Add Variable"}
          pageId={pageId}
          setPageId={setPageId}
          pages={getVariablesPages}
          refetch={documentVariablesRefetch}
          isEdit={false}
        />
      )}

      {showEditModal && (
        <AddEditDocumentVariable
          show={showEditModal}
          size={"lg"}
          handleClose={() => setShowEditModal(false)}
          title={"Edit Variable"}
          pageId={pageId}
          setPageId={setPageId}
          pages={getVariablesPages}
          refetch={documentVariablesRefetch}
          editingVariable={editingVariable}
        />
      )}
    </>
  );
};

export default DocumentVariables;
